var render = function render(){var _vm=this,_c=_vm._self._c;return (this.$store.state.progress)?_c('div',{attrs:{"id":"progress"}},[_c('v-progress-circular',{attrs:{"id":"proggres-circle","size":50,"color":"primary","indeterminate":""}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }